var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57404 3.21684L1.51571 15.0002C1.37018 15.2522 1.29318 15.5379 1.29236 15.8289C1.29155 16.12 1.36695 16.4061 1.51106 16.6589C1.65518 16.9118 1.86298 17.1225 2.1138 17.27C2.36462 17.4176 2.64971 17.497 2.94071 17.5002H17.0574C17.3484 17.497 17.6335 17.4176 17.8843 17.27C18.1351 17.1225 18.3429 16.9118 18.487 16.6589C18.6311 16.4061 18.7065 16.12 18.7057 15.8289C18.7049 15.5379 18.6279 15.2522 18.4824 15.0002L11.424 3.21684C11.2755 2.97193 11.0663 2.76944 10.8167 2.62891C10.5671 2.48838 10.2855 2.41455 9.99904 2.41455C9.71259 2.41455 9.43098 2.48838 9.18138 2.62891C8.93177 2.76944 8.7226 2.97193 8.57404 3.21684V3.21684Z",
    stroke: "#F22B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5V10.8333",
    stroke: "#F22B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667H10.0083",
    stroke: "#F22B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.bd7d340e16933993ab117a590720e616.svg";
export { ForwardRef as ReactComponent };